import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Notification {
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notificationSubject = new Subject<Notification>();
  public notification$ = this.notificationSubject.asObservable();

  success(title: string, message: string) {
    this.show({ type: 'success', title, message, confirmText: 'OK' });
  }

  error(title: string, message: string) {
    this.show({ type: 'error', title, message, confirmText: 'OK' });
  }

  warning(title: string, message: string) {
    this.show({ type: 'warning', title, message, confirmText: 'OK' });
  }

  info(title: string, message: string) {
    this.show({ type: 'info', title, message, confirmText: 'OK' });
  }

  confirm(
    title: string,
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    type: 'warning' | 'info' = 'warning'
  ) {
    this.show({
      type,
      title,
      message,
      confirmText: 'Confirmar',
      cancelText: 'Cancelar',
      onConfirm,
      onCancel
    });
  }

  private show(notification: Notification) {
    this.notificationSubject.next(notification);
  }
}
